import type { TPageId } from "routes/route";

import constate from "constate";
import { Map as ImmutableMap } from "immutable";
import isNil from "lodash/isNil";
import { useCallback, useEffect, useState } from "react";
import { matchPath, useLocation } from "react-router";
import { pageMatches } from "routes/pageMatches";

const usePage = () => {
  const [subPage, setSubPage] = useState<boolean>(false);
  const [scrollableId, setScrollableId] = useState<null | TPageId>(null);
  const location = useLocation();
  const [pageLastState, setPageLastState] = useState(ImmutableMap<TPageId, Record<string, unknown>>());

  useEffect(() => {
    const match = pageMatches.find((route) => route.matches.some((path) => !isNil(matchPath(path, location.pathname))));
    setScrollableId(match?.pageId || null);
  }, [location.pathname]);

  const setLastState = useCallback((pageId: TPageId, state: Record<string, unknown>) => {
    setPageLastState((prevState) => prevState.set(pageId, state));
  }, []);

  const updateLastState = useCallback((pageId: TPageId, state: Record<string, unknown>) => {
    setPageLastState((prevState) => prevState.set(pageId, { ...prevState.get(pageId), ...state }));
  }, []);

  return {
    pageLastState,
    scrollableId,
    setLastState,
    setSubPage,
    subPage,
    updateLastState,
  };
};

export const [PageProvider, usePageContext] = constate(usePage);
